import axios, { AxiosResponse } from 'axios';

// Post metoda pro volani obnovy hesla, ktera nam vraci
const passwordRestoreApi = async (password: string, auth: string, lang: string) => {
    const { status }: AxiosResponse<string> = await axios({
        method: 'POST',
        url: 'Portal/PasswordRestore',
        data: {
            password,
            lang
        },
        headers: {
            Authorization: `Bearer ${auth}`
        }
    });
    return status;
};

export default passwordRestoreApi;
